import React from "react";
import { NavLink } from "react-router-dom";
import "./header.scss";
import { useSelector } from "react-redux";
import LogoCompany from "../../assets/imgs/R_C.png";
import ItemsBalance from "../itemsBalance/itemsBalance";

export function Header({ MyFun, activeBtn, companyBalance, windowWidth }) {
  function pad2(n) {
    return n < 10 ? "0" + n : n;
  }

  const date = new Date();
  const settings = useSelector((state) => state.userSettings);
  const companyLogo =
    settings.companyLogo != null
      ? settings.companyLogo +
        "?v=" +
        date.getFullYear().toString() +
        pad2(date.getMonth() + 1) +
        pad2(date.getDate()) +
        pad2(date.getHours()) +
        pad2(date.getMinutes()) +
        pad2(date.getSeconds())
      : LogoCompany;

  return (
    <header className="wrapper_header trans">
      <div className="box_brand">
        <button
          type={"button"}
          className={`btn_menu ${activeBtn}`}
          onClick={MyFun}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <NavLink to="/home">
          <img src={companyLogo} alt="Brand" />
        </NavLink>
      </div>
      {companyBalance && <ItemsBalance companyBalance={companyBalance} />}
    </header>
  );
}
